var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdvatagesGridItemBg2 = function SvgAdvatagesGridItemBg2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C678",
    d: "M0 13.833C0 6.54 5.912.628 13.205.628S26.41 6.54 26.41 13.833v.747c0 7.293-5.912 13.205-13.205 13.205S0 21.874 0 14.58z"
  })));
};
export { SvgAdvatagesGridItemBg2 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjciIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyNyAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgMTMuODMzMkMwIDYuNTQwMjYgNS45MTIwOSAwLjYyODE3NCAxMy4yMDUgMC42MjgxNzRDMjAuNDk4IDAuNjI4MTc0IDI2LjQxIDYuNTQwMjYgMjYuNDEgMTMuODMzMlYxNC41ODA0QzI2LjQxIDIxLjg3MzQgMjAuNDk4IDI3Ljc4NTUgMTMuMjA1IDI3Ljc4NTVDNS45MTIwOSAyNy43ODU1IDAgMjEuODczNCAwIDE0LjU4MDRWMTMuODMzMloiIGZpbGw9IiNGNEM2NzgiLz4KPC9zdmc+Cg==";